<ng-container *ngIf="shopExist; else NoShop">
  <app-my-tabs [tabs]="tabs" [defaultTabIndex]="selMenu" (tabChange)="updateSelMenu($event)">
    <div class="my-shop" tab0>
      <div class="nav-product">
        <div class="nav-product__title">Anyone</div>
      </div>
      <app-ask #Ask [categoryName]="selectedCategoryName" [subCategoryName]="selectedSubCategoryName"
        [onlyMemberAsk]="true"></app-ask>
    </div>

    <div class="my-shop" tab1 *ngIf="roleService.roles?.level?.includes('MEMBER_JOB_POSTING')">
      <div class="nav-product">
        <div class="nav-product__title">Job Post</div>
      </div>
      <div class="no-product" (click)="openAddPopup(JobPopup)">
        <div>
          <i class="fa fa-plus" (click)="openAddPopup(JobPopup)" aria-hidden="true"></i>
          <span class="pl-2">Add</span>
        </div>
      </div>

      <ng-container *ngFor="let i of jobList">
        <div class="profile">
          <div class="message">
            {{ i.title }}
          </div>
          <div class="detail">
            <div class="cate">
              {{ i.description }}
            </div>
            <i class="fa fa-trash absolute" (click)="deleteJob(i.id)" aria-hidden="true"></i>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="my-shop" tab2>
      <div class="nav-product">
        <div class="nav-product__title">
          For Someone <a routerLink="/faq"> <i class="fa-solid fa-circle-question"></i></a>
        </div>
      </div>
      <div class="my-shop__products-2">
        <div class="my-shop__products-2--item" *ngFor="let i of supportOwnerList">
          <ng-container *ngIf="i.type ==  'community' else biz">
            <img loading="lazy" src="{{ imgUrl }}{{ i?.businessDetails?.profileCharacterImageFile }}" />

            <div class="my-shop__products-2--item__name">
              {{ i?.businessDetails?.profileCharacterName | titlecase }}
            </div>
            <!-- <div class="my-shop__products-2--item__meta">
            <span>{{ i.categoryName }}</span>
          </div> -->
            <div class="my-shop__products-2--item__meta">
              <span>{{ i?.businessDetails?.email }}</span>
            </div>
            <div class="my-shop__products-2--item__control">
              <i class="fa fa-trash" aria-hidden="true" title="delete" (click)="deleteSupport(i?.id)"></i>
            </div>
          </ng-container>
          <ng-template #biz>
            <img loading="lazy" src="{{ imgUrl }}{{ i?.userDetails?.shop_logo }}" />

            <div class="my-shop__products-2--item__name">
              {{ i?.userDetails?.first_name + i?.userDetails?.last_name | titlecase }}
            </div>
            <div class="my-shop__products-2--item__control">
              <i class="fa fa-trash" aria-hidden="true" title="delete" (click)="deleteSupport(i?.id)"></i>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Promote -->
    <div class="my-shop" tab3>
      <div class="nav-product">
        <div class="nav-product__title">Others Products</div>
        <button class="button-2"
          (click)="openShopAction('add_product', 0, selectedCategoryName, selectedSubCategoryName)">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span class="pl-1">Add</span>
        </button>
      </div>
      <div class="form-group">
        <input type="text" class="form-control" [(ngModel)]="searchText" placeholder="Search Product...">
      </div>
      <div class="my-shop__products-2">
        <ng-container *ngFor="let i of productAllProductList | filterBy : filterProp : filterValue">
          <div class="my-shop__products-2--item" *ngIf="i.name.toLowerCase().includes(searchText.toLowerCase())">
            <img loading="lazy" src="{{ imgUrl }}{{ i?.primaryImage }}" />

            <div class="my-shop__products-2--item__name">
              {{ i?.name | titlecase }}
            </div>
            <div class="my-shop__products-2--item__meta">
              <span>{{ i.categoryName }}</span>
            </div>
            <div class="my-shop__products-2--item__meta"><span>{{ i.subCategoryName }}</span> CAT : {{ i?.type }}</div>
            <div class="my-shop__products-2--item__control">
              <i class="fa fa-pencil" aria-hidden="true" title="Edit"
                (click)="openShopAction('edit_product', i, i.categoryName, i.subCategoryName)"></i>
              <i class="fa fa-trash" aria-hidden="true" title="delete"
                (click)="openShopAction('delete_product', i, i.categoryName, i.subCategoryName)"></i>
            </div>
          </div>
        </ng-container>
        <div *ngIf="(productAllProductList | filterBy : filterProp : filterValue).length == 3"
          class="my-shop__products-2--item slots">
          <div><i class="fa fa-plus" aria-hidden="true"></i> Add Slots</div>
        </div>
      </div>
    </div>
    <!-- Promote -->
  </app-my-tabs>
</ng-container>

<ng-template #NoShop>
  <section class="no-shop">
    <span>No Shop</span>
    <div class="justify-content-center">
      <button (click)="openShopProfile()" class="btn btn-secondary">Create Shop</button>
    </div>
  </section>
</ng-template>

<!-- Job Post -->
<ng-template #JobPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <form [formGroup]="form">
      <h2 class="title">Job Post</h2>
      <div class="form-group">
        <input type="text" class="form-control" placeholder="Enter Job title" maxlength="500" formControlName="title" />
      </div>
      <div class="form-group">
        <textarea class="form-control" placeholder="Enter Job Description" id="exampleFormControlTextarea1"
          maxlength="500" formControlName="description" rows="6"></textarea>
      </div>
      <div class="form-group">
        <input type="text" formControlName="applicationDeadline" placeholder="Enter Job End Date" class="form-control"
          [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [ngModelOptions]="{standalone: true}" [min]="minDate"
          [max]="maxDate" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Event Date" />
        <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
      </div>
      <button class="d-flex ml-auto my-button-3" (click)="submitJob()">Save <i class="fa fa-thumbs-up"
          aria-hidden="true"></i></button>
    </form>
  </div>
</ng-template>
<!-- Job Post -->

<app-add-shop #AddShop [enableMemberShop]="true" (shopUpdate)="update($event)"> </app-add-shop>